
export default {
    name: 'app-map',
    data () {
        return {
            image: require('../../assets/images/carte-france.svg'),
            backgroundVideo: require('../../assets/videos/lowbitrate/corse.mp4'),
        }
    },
}
